/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const CaretDown: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path d='M23 6L12 17L1 6' stroke='currentColor' fill='transparent' strokeWidth='2' strokeMiterlimit='10' strokeLinecap='round' />
  </React.Fragment>
)
